import dayjs from 'dayjs';

import { EFeedbacks } from '@enums/api.enum';
import type { Rate } from '@store/trips/tripsSlice';

import client from '../apiClient';

export type FeedbackParam = {
	id: Rate['id'];
};

export type CreateFeedbackParams = {
	name?: string;
	phone?: string;
	contactMe: boolean;
	rating?: number;
	feedback?: string;
	source?: string;
	tripId?: number;
	driverId?: number;
};

export type CreateFeedbackApiResponse = {
	id: Rate['id'];
};

const endpoint = EFeedbacks.endpoint;

const getSingle = <T>({ id }: FeedbackParam) => client.get<T>(`${endpoint}${EFeedbacks.single}${id}`);

const createFeedback = <T>({ name, phone, contactMe, rating, feedback, tripId, driverId, source }: CreateFeedbackParams) => {
	const data = {
		date: dayjs().unix(),
		source,
		reviewer: { name, phone, shouldContactReviewer: contactMe },
		rating,
		feedback,
		trip: tripId,
		...(driverId !== undefined && { driver: driverId }),
	};

	return client.post<T>(endpoint, data);
};

export default {
	getSingle,
	createFeedback,
};
